import {
  collection,
  addDoc,
  query,
  where,
  orderBy,
  getDocs,
  deleteDoc,
  doc,
  Timestamp,
} from 'firebase/firestore';
import { db } from './firebase';
import { Comment } from '../types';
import { createNotification } from './notificationService';

export const addComment = async (
  artworkId: string,
  userId: string,
  userName: string,
  content: string,
  artistId: string
) => {
  const commentData = {
    artworkId,
    userId,
    userName,
    content,
    createdAt: Timestamp.now(),
  };

  const docRef = await addDoc(collection(db, 'comments'), commentData);

  // Notify artist
  if (userId !== artistId) {
    await createNotification(
      artistId,
      'comment',
      'New Comment',
      `${userName} commented on your artwork`,
      undefined,
      `/artwork/${artworkId}`
    );
  }

  return docRef.id;
};

export const getComments = async (artworkId: string): Promise<Comment[]> => {
  const q = query(
    collection(db, 'comments'),
    where('artworkId', '==', artworkId),
    orderBy('createdAt', 'desc')
  );

  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
    createdAt: doc.data().createdAt?.toDate() || new Date(),
  })) as Comment[];
};

export const deleteComment = async (commentId: string) => {
  await deleteDoc(doc(db, 'comments', commentId));
};

export const getCommentsCount = async (artworkId: string): Promise<number> => {
  const q = query(
    collection(db, 'comments'),
    where('artworkId', '==', artworkId)
  );
  const querySnapshot = await getDocs(q);
  return querySnapshot.size;
};